import React from 'react';
import { withRouter, useHistory } from 'react-router-dom';

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox,
    Dialog, DialogTitle, DialogContent,
    InputAdornment
} from '@material-ui/core';
import { useStyles } from "../../styles";
import * as Icons from "../../iconComponents";


const Popup: React.FC<any> = ({ popState, setPopState }): JSX.Element => {
    const classes = useStyles();
    
    React.useEffect(() => {
        //
    }, [])
    
    return (
        <>
            {popState && (<>
            <Dialog
                open={popState}
                onClose={() => setPopState(!popState)}
                className={classes.pcrDialog}
                fullScreen
            >
                <DialogTitle disableTypography>
                    Allergies
                    <IconButton className={"closeButton"} onClick={() => setPopState(!popState)}>
                        <Icons.CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                variant='outlined'
                                InputProps={{
                                    classes: { root: classes.textFieldInput },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                <Icons.RemoveCircleIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>

                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            </>)}
        </>
    );
}

export default React.memo(withRouter(Popup));